module.exports = __webpack_public_path__ + "static/media/stream.18fa6480.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/stream.svg
// module id = 236
// module chunks = 7